import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useI18n } from '@nx/i18n';
import { PublicProfile } from '../../components/profile/PublicProfile';
import { getProfilePageBackdrop } from '../../components/profile/profilePageBackdrop';
import { toProfileViewModel } from '../../components/profile/profileViewModel';
import './profile-public-page.css';
import { mapPreviewPayload } from '../../services/profilePreviewMapper';
import { resolveProfilePreview } from '../../services/profileCallables';

export function PreviewProfilePage() {
  const { token = '' } = useParams();
  const { t } = useI18n();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [viewModel, setViewModel] = useState<ReturnType<typeof toProfileViewModel> | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    void resolveProfilePreview(token)
      .then((payload) => {
        if (cancelled) return;
        const mapped = mapPreviewPayload(payload);
        setViewModel(toProfileViewModel(mapped.profile, mapped.components));
      })
      .catch(() => {
        if (!cancelled) setNotFound(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#d9d2c7]">
        <Loader2 className="h-8 w-8 animate-spin text-[#78665A]" />
      </div>
    );
  }

  if (notFound || !viewModel) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#FAF8F5] px-4">
        <p className="text-lg text-[#3D3328]">{t('profile.preview.notFound')}</p>
        <Link to="/discover" className="text-sm font-semibold text-[#1A1A1A] underline">
          {t('profile.discover.eyebrow')}
        </Link>
      </div>
    );
  }

  return (
    <div
      className="profile-public-page"
      style={{ backgroundColor: getProfilePageBackdrop(viewModel) }}
    >
      <div className="profile-public-page__frame">
        <PublicProfile profile={viewModel} />
      </div>
    </div>
  );
}
